import { Certificate, ICertificate } from '../certificate';

export interface ICertificates {
  additional?: ICertificate[];
  coursesAndSeminars?: ICertificate[];
  main?: ICertificate[];
}

export class Certificates implements ICertificates {
  additional: Certificate[];
  coursesAndSeminars: Certificate[];
  main: Certificate[];

  constructor( certificates: ICertificates = {} ) {
    this.additional = this.transformCersData(certificates.additional);
    this.coursesAndSeminars = this.transformCersData(certificates.coursesAndSeminars);
    this.main = this.transformCersData(certificates.main);
  }

  private transformCersData( certificates: ICertificate[] = [] ): Certificate[] {
    return certificates.map(( certificate ) => new Certificate(certificate));
  }

}



// WEBPACK FOOTER //
// ./app/core/entities/cv/certificates.ts